import React from 'react'

import { Form, Col } from '_zari/core'

const OrigenFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='ORIGEN' htmlFor='input-origen' md={4} />
      <Col md={8}>
        <Form.InputText id='input-origen' name='input-origen' placeholder={value} disabled />
      </Col>
    </Form.Group>
  )
}

export default React.memo(OrigenFormGroup)
